module.exports = __webpack_public_path__ + "img/order-icon.58f718a5.png";